

exports.__esModule = true;
exports.$LandingRoute = undefined;

require('squid/index');

require('xo-models/src/checkout/index');

require('xo-models/src/auth/index');

require('xo-models/src/shippingMethod/index');

require('xo-models/src/inventory/index');

var _squid = require('squid');

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {

    path: 'landing',

    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },

    auth: false,

    resolve: {

        action: function action($window, $feature, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel, $Class, $experiment, $rootScope, $state, $populate, $logger, $q, $config, $AuthModel, $FallbackError, $util, $dispatch, $locale, $pxp, $InventoryModel, $InstallmentOptionsModel, $CreditDataModel, $FlowEligibilityModel) {

            var models = {};

            return $populate(models, {
                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                auth: $AuthModel.instance(),
                checkoutPayeeModel: $CheckoutPayeeModel.instance($rootScope.token),
                flowEligibility: $FlowEligibilityModel.instance($rootScope.token)
            }).then(function () {
                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;
                $logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });

                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
                    var supportBlockNonDomesticShipping = $feature('supportBlockNonDomesticShipping', false, merchantCountry);
                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');

                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
                        $logger.info('block_non_domestic_shipping', {
                            block_non_domestic_shipping: blockNonDomesticShipping,
                            allow_change_shipping: allowChangeShipping,
                            setec_shipping_country_code: prefillShippingAddress
                        });
                    }

                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';

                    if (shouldBlockBuyer) {
                        return {
                            to: 'checkout.genericError',
                            params: {
                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                            }
                        };
                    }

                    if (models.checkoutAppData.is_second_button_txn) {
                        var creditDataModel = $CreditDataModel.instance($rootScope.token);
                        var isCapeReturnKey = creditDataModel.getCapeKey();
                        var isChangeInstallments = creditDataModel.isChangeStatus();
                        var offers = $InstallmentOptionsModel.instance($rootScope.token);
                        var installmentOptions;
                        var isInstallmentEligible = models.flowEligibility.installment;
                        return offers.save({
                            data: {
                                payee: models.checkoutPayeeModel,
                                checkoutCart: models.checkoutCart,
                                checkoutAppData: models.checkoutAppData,
                                isMemberCredit: true
                            },
                            success: function success(result) {
                                installmentOptions = result && result.installments && result.installments[0] && result.installments[0].installment_options && result.installments[0].installment_options.length > 0;

                                if (isCapeReturnKey) {
                                    return 'checkout.login';
                                } else if (isInstallmentEligible && (installmentOptions && isChangeInstallments || installmentOptions)) {
                                    $logger.info('ppc_second_btn_acquisition');
                                    return 'checkout.chooseCreditOffer';
                                } else {
                                    $logger.info('ppc_second_btn_resuse');
                                    return 'checkout.login';
                                }
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    // Check error message === currencyNotCompatible
                                    return 'checkout.login';
                                }
                            }
                        });
                    }

                    return 'checkout.login';
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');
                if ($config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = $InventoryModel.instance($rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };
                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-landing/route.js
 ** module id = 171
 ** module chunks = 1
 **/